import {
  Box,
  IconButton,
  Menu,
  Tooltip,
  Typography,
  MenuItem,
  Dialog
} from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../../app/redux/hooks';
import CustomDataGrid from '../../../../../../common/components/customized/customdatagrid/CustomDataGrid';
import {
  capitalizeFirstLetter,
  convertEpochToDateString,
  convertTo12HourFormat,
  debounce
} from '../../../../../../utils/commonFunctions';
import { Icon } from '@iconify/react';
import constant from '../../../../../../utils/constants';
import CustomBreadcrumbs from '../../../../../../common/components/custombreadcrumbs/CustomBreadcrumbs';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import CustomButton from '../../../../../../common/components/buttons/CustomButton';
import AddTrip from './AddTrip';
import { useForm } from 'react-hook-form';
import CustomTextField from '../../../../../../common/components/customized/customtextfield/CustomTextField';
import {
  autoPlannerBookingAction,
  autoPlannerDeleteAction,
  autoPlannerTripsAction
} from '../../../../redux/reducer/autoPlannerSlices/autoplanner';
import { GridActionsCellItem } from '@mui/x-data-grid';
import ConfirmationPopup from '../../../../../../common/components/confirmationpopup/ConfirmationPopup';

interface Props {
  payloads: any;
  agentName: any;
  setBreadCrumbs: any;
  setExpanded: any;
  clearFilter: any;
  setPageSizes: any;
  pageSizes: number;
  filterPayload: any;
}

interface Row {
  id: number;
  agentname: string;
  guestname: string;
  fromlocation: string;
  tolocation: string;
  startDateTime: string;
  adultcount: number;
  childcount: number;
  referenceid: number;
  tripType: string;
  source: string;
  startLat: number;
  startLng: number;
  target: string;
  passengerJourneys: any[];
  targetLat: number;
  targetLng: number;
  groupId: string;
}

interface Column {
  field: string;
  headerName: string;
  minWidth: number;
  flex: number;
  renderCell?: (params: { row: Row }) => any;
  textAlign?: string;
}

interface PaginationModel {
  page: number;
  pageSize: number;
}

const BookingTsic = ({
  payloads,
  agentName,
  setBreadCrumbs,
  setPageSizes,
  pageSizes,
  setExpanded,
  clearFilter,
  filterPayload
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const BookingData = useAppSelector(state => state.AutoPlannerBooking);
  const [viewOpen, setViewOpen] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState<any | null>(null);
  const [view, setView] = useState<boolean>(false);
  const [filter, setFilter] = useState('');
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isDialog, setIsDialog] = useState('');
  const [pageSize, setPageSize] = useState(pageSizes || 20);
  const [rows, setRows] = useState([]);
  const [tripsRows, setTripsRows] = useState<Row[]>([]);
  const [selectedRow, setSelectedRow] = useState<any | null>(null);
  const [pageNo, setPageNo] = useState(1);
  const [IspageSize, setIsPageSize] = useState(20);
  const [IspageNo, setIsPageNo] = useState(1);
  const [tripPayload, setTripPayload] = useState({ pageNo, pageSize });
  const [rowCount, setRowCount] = useState(0);
  const [IsrowCount, setIsRowCount] = useState(0);
  const [sortModel, setSortModel] = useState<any>([]);
  const [tripsGroupRows, setGroupTripsRows] = useState<Row[]>([]);
  const [bookingsPayload, setBookingsPayload] = useState<any>(null);
  const openMenu = Boolean(anchorEl);

  const tripsData = useAppSelector(state => state.AutoPlannerTrip);
  const { data } = useAppSelector(state => state.auth);
  const Routes = useAppSelector(state => state.autoPlannerRoutes.data || []);
  const Agents = useAppSelector(state => state.autoPlannerAgent.data || []);
  const { isLoading } = useAppSelector(state => state.AutoPlannerDeleteTrip);

  const dispatch = useAppDispatch();

  const { control } = useForm();

  const agentNames =
    Agents?.map((value: string) => ({
      id: value,
      label: capitalizeFirstLetter(value)
    })) || [];

  const configuredRoute =
    Routes?.map((value: string) => ({
      id: value,
      label: value
    })) || [];

  const handleViewGroupTrip = (event: React.MouseEvent<HTMLElement>, params: any) => {
    if (params !== null) {
      setSelectedGroup(params);
      const payload = {
        pageNo: 1,
        pageSize: 20,
        tourName: params.tourName,
        mode: 'TSIC',
        data: params.date,
        agentName: agentName
      };
      setBookingsPayload(payload);
      dispatch(autoPlannerBookingAction(payload));
      setView(true);
    }
  };

  const handleSortModelChange = (model: any) => {
    setSortModel(model);
    const payload = {
      ...tripPayload,
      sortBy: model[0]?.sort,
      sortByField: model[0]?.field
    };
    setTripPayload(payload);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleViewTrip = () => {
    handleMenuClose();
    setViewOpen(true);
  };

  const handleUpdateTrip = () => {
    handleMenuClose();
    setIsOpen(true);
  };

  const handleDeleteTrip = async () => {
    if (selectedRow) {
      const payload = {
        selectedRow: selectedRow,
        tripMode: 'TSIC',
        pageDetails: { pageNo, pageSize }
      };
      await dispatch(autoPlannerDeleteAction(payload));
      setIsDialog('');
    }
  };

  // for search
  const handleFilterChange = useCallback(
    debounce((event: string) => {
      setFilter(event);
      if (rows) {
        const payloadTSIC = {
          ...tripPayload,
          tripMode: 'TSIC',
          search: event
        };
        setTripPayload(payloadTSIC);
        dispatch(autoPlannerTripsAction(payloadTSIC));
      }
    }),
    [tripPayload]
  );

  const handleMenuClick = (row: Row) => {
    if (selectedGroup !== null) {
      const value = {
        source: row.source,
        startLat: row.startLat,
        startLng: row.startLng,
        // startTimestamp: selectedGroup.startTimestamp,
        destination: selectedGroup.destination,
        endLat: selectedGroup.endLat,
        endLng: selectedGroup.endLng,
        endTimestamp: selectedGroup.endTimestamp,
        tripTotalDuration: selectedGroup.tripTotalDuration,
        mode: selectedGroup.mode
      };
      setSelectedRow({ ...row, ...value, ...selectedGroup });
    }
  };

  const handleBookingsPaginationModelChange = (newPaginationModel: PaginationModel) => {
    const { pageSize: newPageSize, page: newPageNo } = newPaginationModel;
    setIsPageSize(newPageSize);
    setIsPageNo(newPageNo + 1);
    const newPage = newPageNo + 1;
    const payload = {
      ...bookingsPayload,
      pageNo: newPage,
      pageSize: newPageSize
    };
    dispatch(autoPlannerBookingAction(payload));
  };

  const handlePaginationModelChange = (newPaginationModel: PaginationModel) => {
    const { pageSize: newPageSize, page: newPageNo } = newPaginationModel;
    setPageSize(newPageSize);
    setPageNo(newPageNo + 1);
    const newPage = newPageNo + 1;
    const payload = {
      ...tripPayload,
      pageNo: newPage,
      pageSize: newPageSize
    };
    setTripPayload(payload);
  };

  const groupColumns: Column[] = [
    {
      field: 'actions',
      headerName: 'Action',
      minWidth: 150,
      flex: 1,
      renderCell: (params: any) => (
        <Box
          onClick={event => {
            event.stopPropagation();
            handleViewGroupTrip(event, params.row);
          }}
        >
          <Tooltip title='View group bookings' arrow>
            <Typography className='view-routes'>View Bookings</Typography>
          </Tooltip>
        </Box>
      )
    },

    {
      field: 'tourName',
      headerName: 'Tour Name',
      minWidth: 230,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },

    {
      field: 'date',
      headerName: 'Trip Date',
      minWidth: 120,
      flex: 1
    },

    {
      field: 'pickupWindow',
      headerName: 'Pickup Time Window',
      minWidth: 200,
      flex: 1
    },
    {
      field: 'returnTime',
      headerName: 'Return Time',
      minWidth: 120,
      flex: 1
    },
    {
      field: 'mode',
      headerName: 'Tour Mode',
      minWidth: 120,
      flex: 1
    },
    {
      field: 'totalAdultCount',
      headerName: 'Adult Count',
      minWidth: 100,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.row.totalAdultCount} arrow>
          <Box
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%'
            }}
          >
            {params.row.totalAdultCount}
          </Box>
        </Tooltip>
      )
    },
    {
      field: 'totalChildCount',
      headerName: 'Child Count',
      minWidth: 100,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.row.totalChildCount} arrow>
          <Box
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%'
            }}
          >
            {params.row.totalChildCount}
          </Box>
        </Tooltip>
      )
    },
    {
      field: 'netCount',
      headerName: 'Total Passenger',
      minWidth: 130,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.row.netCount} arrow>
          <Box
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%'
            }}
          >
            {params.row.netCount}
          </Box>
        </Tooltip>
      )
    }
  ].map((item: any) => ({
    ...item,
    sortable: false,
    align: ['actions']?.includes(item?.field) ? 'center' : 'left',
    headerAlign: ['actions']?.includes(item?.field) ? 'center' : 'left'
  }));

  const columns: Column[] = [
    {
      field: 'actions',
      headerName: 'Action',
      type: 'actions',
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      getActions: (params: any) => {
        const actions = [
          <GridActionsCellItem
            icon={<Icon icon='ic:baseline-edit' className='menu-icon update' />}
            label={constant.Update}
            onClick={() => {
              handleMenuClick(params.row);
              handleUpdateTrip();
            }}
            showInMenu
          />
        ];
        if (data?.role === 'ROLE_OPERATOR' || data?.role === 'ROLE_AUTOPLANNER_ADMIN') {
          actions.push(
            <GridActionsCellItem
              icon={
                <Icon
                  icon='ic:outline-delete'
                  className='menu-icon'
                  style={{ color: '#FF4343' }}
                />
              }
              label={constant.Delete}
              onClick={() => {
                handleMenuClick(params.row);
                setIsDialog('Delete');
                handleMenuClose();
              }}
              showInMenu
            />
          );
        }

        return actions;
      }
    },

    { field: 'agent_name', headerName: 'Agent Name', minWidth: 200, flex: 1 },
    {
      field: 'guest_name',
      headerName: 'Guest Name',
      minWidth: 200,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    {
      field: 'guestContactNumber',
      headerName: 'Guest Contact Number',
      minWidth: 200,
      flex: 1,
      valueGetter: (params: any) => (params.value ? params.value : '-')
    },
    { field: 'adult_count', headerName: 'Adult Count', minWidth: 130, flex: 1 },
    { field: 'child_count', headerName: 'Child Count', minWidth: 130, flex: 1 },
    {
      field: 'reference',
      headerName: 'Reference ID',
      minWidth: 120,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    {
      field: 'transferPickup',
      headerName: 'Pickup Location',
      minWidth: 250,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    }
  ].map((item: any) => ({ ...item, sortable: false }));

  useEffect(() => {
    if (
      BookingData?.data?.data !== null &&
      BookingData?.data?.data?.passengerJourneyInfoList
    ) {
      const data = BookingData?.data?.data?.passengerJourneyInfoList?.map(
        (item: any, index: number) => ({
          ...item,
          sno: index + 1,
          id: item.trip_id,
          transferLocation: item.transfer_info?.pickupCoordinates,
          transferTripInfo: item.transfer_info ? 'Yes' : 'No',
          reference: item.ref_number ? item.ref_number : '-',
          transferPickup: item.source ? item.source : '-',
          pickupTimestamp: item.transfer_info
            ? convertEpochToDateString(item.transfer_info.pickupTimestamp)
            : '-'
        })
      );
      setTripsRows(data);
      setIsRowCount(BookingData?.data?.data.count);
    } else {
      setTripsRows([]);
    }
  }, [BookingData]);

  useEffect(() => {
    if (tripsData?.data?.data !== null && tripsData?.data?.data?.groupedTrips) {
      setRows(tripsData.data.data.groupedTrips);
      setRowCount(tripsData.data.data.count || 0);
    } else {
      setRows([]);
    }
  }, [tripsData?.data]);

  useEffect(() => {
    if (rows?.length > 0) {
      const data = rows?.map((item: any, index: number) => {
        const [startTime, endTime] =
          typeof item?.pickupWindow === 'string' && item.pickupWindow.includes('-')
            ? item.pickupWindow.split('-')
            : ['', ''];

        return {
          ...item,
          sno: index + 1,
          id: index + 1,
          // startTimestamp: convertEpochToDateString(item.startTimestamp),
          pickupWindow: startTime
            ? `${convertTo12HourFormat(startTime)} - ${convertTo12HourFormat(endTime)}`
            : '-',
          returnTime: item.returnTime ? convertTo12HourFormat(item.returnTime) : '-'
        };
      });
      setGroupTripsRows(data);
    } else setGroupTripsRows([]);
  }, [rows]);

  const payloadSIC = {
    ...payloads,
    ...tripPayload,
    tripMode: 'TSIC'
  };

  // useEffect(() => {
  //   if (payload) {
  //     const payloadSIC = {
  //       ...payload,
  //       tripMode: 'TSIC'
  //     };
  //     setTripPayload({ ...payload, tripMode: 'TSIC' });
  //     dispatch(autoPlannerTripsAction(payloadSIC));
  //   }
  // }, [payload]);

  useEffect(() => {
    if (tripPayload) {
      const payloadSIC: any = {
        ...tripPayload,
        tripMode: 'TSIC'
      };

      if (payloadSIC?.autoplannerID) {
        dispatch(autoPlannerTripsAction(payloadSIC));
      }
    }
  }, [tripPayload]);

  useEffect(() => {
    setBreadCrumbs({
      setViews: setView,
      views: view,
      setPageNo: setPageNo,
      setPageSize: setPageSize
    });
  }, [view]);

  useEffect(() => {
    const payload = {
      ...tripPayload,
      ...payloads
    };
    setTripPayload(payload);
  }, [payloads]);

  useEffect(() => {
    if (pageSize) setPageSizes(pageSize);
  }, [pageSize]);

  return (
    <Box>
      <Box className='trip-datas'>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%'
          }}
        >
          <CustomBreadcrumbs
            className='tracking-heading'
            itemOne={'Tour'}
            itemTwo={'Bookings'}
            itemTwoState={view}
            setView={setView}
            handleItemOneClick={() => {
              if (view) dispatch(autoPlannerTripsAction(payloadSIC));
            }}
          />
          {!view && (
            <Box sx={{ width: 200 }}>
              <CustomTextField
                name='search'
                control={control}
                id='filter-input'
                placeholder='Search...'
                value={filter}
                variant='standard'
                icon={<SearchOutlinedIcon color='primary' />}
                onChangeCallback={(e: any) => handleFilterChange(e)}
              />
            </Box>
          )}
        </Box>
        {!view ? (
          <CustomDataGrid
            rows={tripsGroupRows}
            sortingMode='server'
            columns={groupColumns}
            loading={tripsData?.isLoading}
            onSortModelChange={handleSortModelChange}
            onRowClick={(event: any, row) => {
              handleViewGroupTrip(event, row);
              setSelectedGroup(row);
            }}
            rowCount={rowCount}
            type='logistics'
            onPaginationModelChange={handlePaginationModelChange}
            pageNo={pageNo}
            pageSize={pageSize}
            paginationModel={{
              page: pageNo ? pageNo - 1 : 0,
              pageSize: pageSize ? pageSize : 10
            }}
          />
        ) : (
          <CustomDataGrid
            rows={tripsRows}
            rowCount={IsrowCount}
            columns={columns}
            pageNo={IspageNo}
            onRowClick={(event: any, row) => {
              handleUpdateTrip();
              if (selectedGroup !== null) {
                const value = {
                  source: row.source,
                  startLat: row.startLat,
                  startLng: row.startLng,
                  // startTimestamp: selectedGroup.startTimestamp,
                  destination: selectedGroup.destination,
                  endLat: selectedGroup.endLat,
                  endLng: selectedGroup.endLng,
                  endTimestamp: selectedGroup.endTimestamp,
                  tripTotalDuration: selectedGroup.tripTotalDuration,
                  mode: selectedGroup.mode
                };
                setSelectedRow({ ...row, ...value, ...selectedGroup });
              }
            }}
            type='autoplanner'
            pageSize={IspageSize}
            loading={BookingData?.isLoading}
            onPaginationModelChange={handleBookingsPaginationModelChange}
          />
        )}
      </Box>

      <Dialog open={isDialog === 'Delete'}>
        <Box
          sx={{
            textAlign: 'center',
            padding: '5%',
            minWidth: '350px'
          }}
        >
          <Typography>{constant.DeleteTrip}</Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              paddingTop: '5%',
              justifyContent: 'center'
            }}
          >
            <Box sx={{ marginRight: '12px' }}>
              <CustomButton
                className='saveChanges'
                category='Yes'
                loading={isLoading}
                onClick={() => {
                  handleDeleteTrip();
                }}
              />
            </Box>
            <CustomButton
              className='cancel'
              category='No'
              onClick={() => setIsDialog('')}
            />
          </Box>
        </Box>
      </Dialog>
      {/* {isDialog === 'Delete' && (
        <ConfirmationPopup
          open={isDialog === 'Delete'}
          loading={isLoading}
          onClose={() => setIsDialog('')}
          onConfirm={() => {
            handleDeleteTrip();
          }}
          title='Delete Booking'
          messages={[
            'This booking includes scheduled entries.',
            'Deleting it will also remove all associated schedules.'
          ]}
          confirmText='Yes, Delete'
          cancelText='No'
        />
      )} */}

      {isOpen && (
        <AddTrip
          isOpen={isOpen}
          filterPayload={filterPayload}
          setIsOpen={setIsOpen}
          selectedRow={selectedRow}
          pageDetails={tripPayload}
          selectedGroup={selectedGroup}
          // setTripMode={handleTrip}
          Agents={agentNames}
          Routes={configuredRoute}
        />
      )}
    </Box>
  );
};

export default BookingTsic;
